// src/hook/useLeads.js
import { useCallback, useState } from "react";
import { useAuth } from "./";
import { getLeads, deleteLead } from "../api/crm";

export function useLeads() {
  const { auth } = useAuth();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [leads, setLeads] = useState([]);

  const fetchLeads = useCallback(
    async (params = {}) => {
      try {
        setLoading(true);
        const data = await getLeads(auth.token, { page_size: 100, ...params });
        setLeads(Array.isArray(data) ? data : (data?.results || []));
        setLoading(false);
      } catch (err) {
        setLoading(false);
        setError(err);
        console.error(err);
      }
    },
    [auth.token]
  );

  const removeLead = useCallback(
    async (id) => {
      try {
        setLoading(true);
        await deleteLead(id, auth.token);
        setLoading(false);
        return true;
      } catch (err) {
        setLoading(false);
        setError(err);
        throw err;
      }
    },
    [auth.token]
  );

  return { loading, error, leads, fetchLeads, removeLead };
}
